import request from '@/plugin/axios'

export function page(query) {
    return request({
        url: '/api/case/caseRecords/masterCaseList',
        method: 'post',
        params: query
    })
}

export function addObj(obj) {
    return request({
        url: '/api/case/caseRecords',
        method: 'post',
        data: obj
    })
}

export function getObj(id) {
    return request({
        url: '/api/case/caseRecords/' + id,
        method: 'get'
    })
}

export function delObj(id) {
    return request({
        url: '/api/case/caseRecords/' + id,
        method: 'delete'
    })
}

export function putObj(id, obj) {
    return request({
        url: '/api/case/caseRecords/' + id,
        method: 'put',
        data: obj
    })
}

export function getAllUser() {
    return request({
        url: '/api/admin/user/all',
        method: 'get'
    })
}


export function assignmentCase( obj) {
    return request({
        url: '/api/case/caseRecords/assignmentCase',
        method: 'post',
        params: obj
    })
}

